import { createI18n } from 'vue-i18n';
import da from '../locales/da.json';
import de from '../locales/de.json';
import enUS from '../locales/en-US.json';
import es from '../locales/es.json';
import fi from '../locales/fi.json';
import frCA from '../locales/fr-CA.json';
import frFR from '../locales/fr-FR.json';
import it from '../locales/it.json';
import nl from '../locales/nl.json';
import no from '../locales/no.json';
import ptBR from '../locales/pt-BR.json';
import ptPT from '../locales/pt-PT.json';
import sv from '../locales/sv.json';
export function setupVueI18n(locale = 'en-US') {
    const i18n = createI18n({
        locale: locale,
        globalInjection: true,
        legacy: false,
        runtimeOnly: true,
        fallbackLocale: 'en-US',
        messages: {
            'en-US': enUS,
            es,
            de,
            'fr-CA': frCA,
            'fr-FR': frFR,
            'pt-BR': ptBR,
            'pt-PT': ptPT,
            it,
            nl,
            sv,
            da,
            fi,
            no,
        },
    });
    if (window?.paymentLinksEditorApp)
        window.paymentLinksEditorApp.use(i18n);
    return i18n;
}
